// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
// import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/alpha-logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Alpha Group",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "#",
    },
    {
      icon: <TwitterIcon />,
      link: "#",
    },
    {
      icon: <GitHubIcon />,
      link: "#",
    },
    {
      icon: <YouTubeIcon />,
      link: "#",
    },
  ],
  menus: [
    {
      name: "quick links",
      items: [
        { name: "home", route: "/" },
        { name: "opportunities", route: "/careers" },
        { name: "about us", route: "/pages/landing-pages/about-us" },
      ],
    },
    {
      name: "locations",
      items: [
        { name: "Mauritius — Ebene", route: "/mauritius-projects" },
        { name: "Azerbaijan — Baku", route: "/azerbaijan-projects" },
      ],
    },
  ],
  offices: [
    {
      name: "Mauritius Office",
      address: [
        "7th Floor, Office 13",
        "Icon Ebene Building",
        "Rue de l'Institut",
        "Ebene, Mauritius",
      ],
    },
    {
      name: "Azerbaijan Office",
      address: ["19th Floor, Port Baku Towers", "155 Neftchilar Ave", "Baku 1010, Azerbaijan"],
    },
  ],
  copyright: `All rights reserved. Copyright © ${date} Alpha Group Private Limited.`,
};
